// Route wrapper for the Local Access Keys screen: binds which row's revoke
// confirmation is open to the URL (?confirmRevoke={keyId}).
//
// A destructive prompt that survives a refresh is deliberate — the operator sees
// what they were about to do rather than silently losing it. The one-time RAW
// key reveal is NOT routed: a secret must never enter the address bar.
import { useNavigate, useSearch } from '@tanstack/react-router';
import { LocalKeysScreen } from './LocalKeysScreen';

export function KeysRoute() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { confirmRevoke?: string };
  return (
    <LocalKeysScreen
      confirmRevoke={search.confirmRevoke ?? null}
      onConfirmRevokeChange={(keyId) =>
        void navigate({ to: '/keys', search: keyId ? { confirmRevoke: keyId } : {} })
      }
    />
  );
}
